import { Image } from "antd";
import Assets from "../../../../../applications/assets";
import "../styles/HomePageFooter.scss";
import FacebookFilled from "@ant-design/icons/lib/icons/FacebookFilled";
import MailOutlined from "@ant-design/icons/lib/icons/MailOutlined";
import PhoneOutlined from "@ant-design/icons/lib/icons/PhoneOutlined";

function HomeFooter() {
  return (
    <footer className="home-footer">
      <div className="footer-container">
        {/* Company info */}
        <div className="footer-col company">
          {/* <Image
            src={Assets.LOGO_HIGHLANDS}
            preview={false}
            className="footer-logo"
          /> */}

          <p className="desc">
            Toputii Coffee® là nhà phân phối hợp lệ cho tất cả sản phẩm mang thương hiệu Toputii®.
          </p>

          <p>📍 Địa chỉ: ĐT310, Thiện Kế - Bình Xuyên - Vĩnh Phúc - Việt Nam</p>
          <p>
            <PhoneOutlined /> Số điện thoại: <a href="tel:0836112000">0836112000</a>
          </p>
          <p>
            <MailOutlined /> Email:{" "}
            <a href="mailto:nguyenhungcuong1206@gmail.com">nguyenhungcuong1206@gmail.com</a>
          </p>
          <p>
            <FacebookFilled /> Facebook:{" "}
            <a
              href="https://www.facebook.com/profile.php?id=100083620292263"
              target="_blank"
              rel="noopener noreferrer"
            >
              Toputii
            </a>
          </p>
        </div>

        {/* Policy */}
        <div className="footer-col">
          <h4>Chính sách</h4>
          <ul>
            <li>Chính sách đặt hàng</li>
            <li>Chính sách bảo mật</li>
          </ul>
        </div>

        {/* Support */}
        <div className="footer-col">
          <h4>Hỗ trợ</h4>
          <ul>
            <li>Đăng nhập</li>
            <li>Đăng ký</li>
            <li>Giỏ hàng</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">© 2025 Toputii Coffee | Cung cấp bởi Louis</div>
    </footer>
  );
}

export default HomeFooter;
